import { render, staticRenderFns } from "./ChatRecodSearchDetailComp.vue?vue&type=template&id=5a576ff6&"
import script from "./ChatRecodSearchDetailComp.vue?vue&type=script&lang=js&"
export * from "./ChatRecodSearchDetailComp.vue?vue&type=script&lang=js&"
import style0 from "./ChatRecodSearchDetailComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports